<template>
    <v-chip class="py-2 my-2 mx-1" >
        {{file.name}}
        <v-btn :loading="loading" @click="delete_file" fab icon color="primary">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-chip>
</template>

<script>
    export default {
        name: "WorkFileChip",
        props:{
            file:{
                type:Object,
                required:true
            }
        },
        data(){
            return{
                loading:false
            }
        },
        methods:{
            delete_file(){
                this.loading=true
                axios.delete(apiRoutes.work.fileDelete+this.file.id).then(response=>{
                    this.loading=false
                    this.$emit("fileDeleted")
                })
            }
        }
    }
</script>

<style scoped>

</style>